<template>
  <section>
    <h2>The potential Ethical Implications</h2>
  </section>
</template>
